import React from 'react'
import TopHeader from '../home/TopHeader'
import Breadcrumbs from '../common/Breadcrumbs'
import Footer from '../home/Footer'

export default function Cancellation() {
  return (
    <div>
      <TopHeader />
      <Breadcrumbs main={"Shipping & Delivery Policy"} parent={"Shipping & Delivery Policy"} />
      <div className='container'>
        <h4>Shipping & Delivery Policy</h4>
        <p>
          At H N Store, we are committed to ensuring that your business orders are shipped
          and delivered on time. This Shipping & Delivery Policy outlines our practices for
          order processing, shipping timelines, and delivery expectations. By placing an order
          with us, you agree to the terms described below.
        </p>

        <h4>Order Processing</h4>
        <ul>
          <li>
            <strong>Processing Time:</strong> Orders are typically processed within{" "}
            <strong>1–3 business days</strong> after payment confirmation.
          </li>
          <li>
            <strong>Bulk Orders:</strong> For large or customized B2B orders, processing time
            may be longer. Customers will be informed of estimated timelines before dispatch.
          </li>
          <li>
            <strong>Working Days:</strong> Processing and shipping occur from{" "}
            <strong>Monday to Saturday</strong>, excluding public holidays.
          </li>
        </ul>

        <h4>Shipping Methods</h4>
        <ul>
          <li>
            We partner with reputed logistics providers to ensure safe and timely deliveries.
          </li>
          <li>
            <strong>Domestic Shipping:</strong> Orders within India are shipped through standard
            courier services, with an estimated delivery time of{" "}
            <strong>3–7 business days</strong> depending on the location.
          </li>
          <li>
            <strong>International Shipping:</strong> Available on request. Delivery timelines
            depend on the destination country and customs clearance.
          </li>
          <li>
            <strong>Freight & Bulk Orders:</strong> For high-volume shipments, delivery may
            be arranged through freight forwarding partners.
          </li>
        </ul>

        <h4>Delivery Timelines</h4>
        <p>
          Delivery times are estimates and may vary due to factors such as logistics delays,
          weather conditions, customs procedures (for international orders), or other
          unforeseen events. We will make reasonable efforts to keep you informed of
          delays.
        </p>

        <h4>Shipping Costs</h4>
        <ul>
          <li>Shipping charges are calculated based on order weight, dimensions, and delivery location.</li>
          <li>For bulk or B2B orders, special shipping arrangements may be provided at negotiated rates.</li>
          <li>Any applicable duties, taxes, or customs fees for international deliveries are the responsibility of the buyer.</li>
        </ul>

        <h4>Order Tracking</h4>
        <p>
          Once your order has been dispatched, a tracking number will be provided via email.
          Customers can use this number to track their shipment in real time through our
          logistics partner’s website.
        </p>

        <h4>Non-Delivery or Delays</h4>
        <ul>
          <li>If an order cannot be delivered due to incorrect shipping details provided by the customer, re-shipping charges may apply.</li>
          <li>In case of unavoidable delays, our support team will notify you and provide the best possible resolution.</li>
        </ul>

        <h4>Contact Us</h4>
        <p>
          For shipping or delivery-related queries, please contact our logistics support team: <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:hnstoreuser@gmail.com">hnstoreuser@gmail.com</a> <br />
        </p>
      </div>
      <Footer />
    </div>
  )
}
